import gql from 'graphql-tag';

import {
    alternateEntryBalance,
    clientOrder,
    creditBalance,
    lectureInstance,
    lectureTerm,
    notRegisteredUserReservation,
    passBalance,
    userReservations,
    workshop,
} from '../fragments';

export const createNotRegisteredUserReservation = gql`
    mutation CreateNotRegisteredUserReservation($input: NotRegisteredUserReservationInput!) {
        createNotRegisteredUserReservation(input: $input) {
            ...NotRegisteredUserReservationFragment
            lectureTermInstance {
                ...LectureTermFragment
                lectureInstance {
                    ...LectureInstanceFragment
                }
            }
        }
    }
    ${notRegisteredUserReservation}
    ${lectureTerm}
    ${lectureInstance}
`;

export const createWorkshopOrder = gql`
    mutation CreateWorkshopOrder($input: WorkshopOrderInput!) {
        createWorkshopOrder(input: $input) {
            clientOrder {
                ...ClientOrderFragment
            }
            creditBalance {
                ...CreditBalanceFragment
            }
            passBalance {
                ...PassBalanceFragment
            }
            alternateEntry {
                ...AlternateEntryBalanceFragment
            }
        }
    }
    ${clientOrder}
    ${creditBalance}
    ${passBalance}
    ${alternateEntryBalance}
`;

export const createCourseOrder = gql`
    mutation CreateCourseOrder($input: CourseOrderInput!) {
        createCourseOrder(input: $input) {
            reservations {
                ...UserReservationFragment
            }
            creditBalance {
                ...CreditBalanceFragment
            }
            passBalance {
                ...PassBalanceFragment
            }
            alternateEntry {
                ...AlternateEntryBalanceFragment
            }
        }
    }
    ${userReservations}
    ${creditBalance}
    ${passBalance}
    ${alternateEntryBalance}
`;

export const createRegisteredUserMakeUpReservation = gql`
    mutation CreateRegisteredUserMakeUpReservation($input: RegisteredUserMakeUpReservationInput!) {
        createRegisteredUserMakeUpReservation(input: $input) {
            reservations {
                ...UserReservationFragment
                lectureTermInstance {
                    ...LectureTermFragment
                    lectureInstance {
                        ...LectureInstanceFragment
                    }
                }
            }
            creditBalance {
                ...CreditBalanceFragment
            }
            passBalance {
                ...PassBalanceFragment
            }
            alternateEntry {
                ...AlternateEntryBalanceFragment
            }
        }
    }
    ${userReservations}
    ${lectureTerm}
    ${lectureInstance}
    ${creditBalance}
    ${passBalance}
    ${alternateEntryBalance}
`;

export const createRegisteredUserReservation = gql`
    mutation CreateRegisteredUserReservation($input: RegisteredUserReservationInput!) {
        createRegisteredUserReservation(input: $input) {
            reservations {
                ...UserReservationFragment
                lectureTermInstance {
                    ...LectureTermFragment
                    lectureInstance {
                        ...LectureInstanceFragment
                    }
                }
            }
            creditBalance {
                ...CreditBalanceFragment
            }
            passBalance {
                ...PassBalanceFragment
            }
            alternateEntry {
                ...AlternateEntryBalanceFragment
            }
        }
    }
    ${userReservations}
    ${lectureTerm}
    ${lectureInstance}
    ${creditBalance}
    ${passBalance}
    ${alternateEntryBalance}
`;

export const createReservationByOffice = gql`
    mutation CreateReservationByOffice($input: ReservationByOfficeInput!) {
        createReservationByOffice(input: $input) {
            ...UserReservationFragment
            lectureTermInstance {
                id
                lectureTermId
            }
            user {
                id
                userId
                name
                email
                phone
                image
            }
        }
    }
    ${userReservations}
`;

export const createWorkshopOrderByOffice = gql`
    mutation CreateWorkshopOrderByOffice($input: ReservationWorkshopByOfficeInput!) {
        createWorkshopOrderByOffice(input: $input) {
            ...WorkshopFragment
            clientOrders {
                ...ClientOrderFragment
            }
        }
    }
    ${workshop}
    ${clientOrder}
`;
